<template>
  <component
    :is="tag"
    ref="root"
    class="sp-finder-specialty-grid"
    flex
    direction="column"
    align-items="center"
    justify-content="center"
  >
    <slot />
  </component>
</template>

<script setup>
import { onMounted, useTemplateRef } from "vue";
import { useDefaults } from "#ce/composables/useDefaults";
import { getSlotContentByTagNameDeep } from "#ce/utils/slots";

const root = useTemplateRef("root");
const props = defineProps({
  tag: {
    type: String,
    default: "sp-container",
  },
});

useDefaults(props, root, "SpFinderSpecialtyGrid");

const DEFAULT_ICON_BACKGROUND_COLOR = "var(--sp-comp-finder-specialty-grid-icon-bg-default, #8ccde6)";
const DEFAULT_FILLED_ICON = "specialty-filled";

// A featured specialty with no curated icon_name produces an empty glyph base: the
// tile builders concatenate the variant suffix onto a blank name, yielding `icon="-filled"`.
// `sp-tile` still renders an <sp-icon> (icon is truthy) but the name resolves to no asset,
// so the tile became a filled circle with no glyph. Fall back to the generic specialty glyph
// (the model-level icon fallback) so the circle always shows something meaningful.
function normalizeTileIcons() {
  for (const tile of getSlotContentByTagNameDeep(root.value, "sp-tile")) {
    let icon = tile.getAttribute("icon");

    if (icon === "-filled") {
      icon = DEFAULT_FILLED_ICON;
      tile.setAttribute("icon", icon);
    }

    // Filled specialty glyphs sit on a coloured circle. `doctor_finder_landing_tile`
    // supplies `icon-background-color` per specialty; tiles built without it (e.g. the
    // Events featured navigation) get the themeable grid default so the circle renders.
    if (icon?.endsWith("-filled") && !tile.hasAttribute("icon-background-color")) {
      tile.setAttribute("icon-background-color", DEFAULT_ICON_BACKGROUND_COLOR);
    }
  }
}

onMounted(normalizeTileIcons);
</script>
